<template>
  <div
    class="flex flex-col"
    :class="containerStyleClasses ?? 'w-full'"
  >
    <div
      class="flex w-full my-1"
      :class="[arrangeLabelAndInputVertically? 'flex-col items-start justify-center' : 'flex-row items-center justify-start']"
    >
      <label
        v-if="labelText"
        :for="fieldName"
        :class="[labelStyleClasses, arrangeLabelAndInputVertically? 'my-1.5' : 'mr-2','text-sm']"
      >{{
        labelText
      }}</label>
      <div class="flex flex-row w-full items-center justify-center">
        <input
          :value="modelValue"
          @input="emitInput"
          @blur="onBlur()"
          v-maska
          :data-maska="props.mask"
          :placeholder="placeholderText"
          :class="[
            'w-full h-10 border rounded focus:outline-none shadow-inner px-2',
            errors.length > 0
              ? 'border-a-error'
              : isReadOnly ?
                'bg-a-neutral-dim'
                : 'border-a-neutral-dim hover:border-a-neutral-lightest focus:border-a-primary',
          ]"
          :readonly="isReadOnly"
          :autofocus="isAutoFocused"
        />
        <template v-if="showErrorIcon">
          <span v-show="errors.length > 0">
            <Icon
              name="mdi:close-circle"
              class="text-lg text-a-error mx-2"
            />
          </span>
        </template>
      </div>
    </div>
    <div class="flex flex-row">
      <span class="text-a-error text-xs md:text-sm flex flex-row items-center">
        {{ errors[0] }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
const baseInputRef = ref(null);
const emit = defineEmits([
  "update:model-value",
]);

const props = withDefaults(defineProps<{
  modelValue: string | number | null;
  labelText?: string;
  labelStyleClasses?: string;
  arrangeLabelAndInputVertically?: boolean;
  mask?: string;
  placeholderText?: string;
  fieldName: string;
  validationLabel?: string;
  isRequired?: boolean;
  showErrorIcon?: boolean;
  isReadOnly?: boolean,
  containerStyleClasses?: string;
  isAutoFocused?: boolean;
}>(), {
  labelText: "",
  labelStyleClasses: "",
  placeholderText: "",
  mask: "(###)###-####",
  validationLabel: "Field",
  isRequired: false,
  isReadOnly: false,
  containerStyleClasses: "",
  showErrorIcon: true,
  isAutoFocused: false
});



//Reg Exp based validation is no more needed as Maska pattern is ensuring Phone input formatting
const regex = ref("^");
const regexObj = ref({});
const validationObject = ref<{
  required: boolean,
  regex: null | RegExp
}>({
  required: props.isRequired,
  regex: null,
})

onMounted(() => generateRegularExpressionFromMask());
function generateRegularExpressionFromMask() {
  let x = 0;
  [...props.mask].forEach((char, key) => {
    if (char === "#") {
      x++;
    }
    else if (char === '+') {
      regex.value += '\\+';
    }
    else {
      if (x > 0) {
        regex.value += "\\d{" + x + "}";
      }
      x = 0;
      if (char == "(" || char == ")") {
        regex.value += "\\" + char;
      } else {
        regex.value += char;
      }
    }
  });
  if (x > 0) {
    regex.value += "\\d{" + x + "}";
  }
  regex.value += "$";
  regexObj.value = new RegExp(regex.value);
  validationObject.value.regex = new RegExp(regex.value);
}

function onBlur() {
  validate();
}

const { validate, errors } = useField(() => {
  return props.fieldName
}, validationObject.value, { syncVModel: true, label: props.validationLabel });


function emitInput(event: Event) {
  const element = event.target as HTMLInputElement;
  emit(
    "update:model-value",
    element.value
  );
}


</script>
